import {
  Button,
  Card,
  Switch,
  Table,
  Tooltip,
  Form,
  Input,
  Modal,
  Row,
  Col,
  DatePicker,
  Select,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import {
  BlockCustomerReasons,
  DeleteCustomerReasons,
} from "../../constants/reasons";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { APIServices } from "../../services/AuthAPIs";
import { useNavigate } from "react-router";
import SendMediaForm from "../../modals/SendMediaForm";
import { UndoOutlined } from "@ant-design/icons";
import { challengeCategory, challengeDuration } from "../../helper/functions";
const Search = Input.Search;
const { RangePicker } = DatePicker;

function Index() {
  const heading = "User Challenge Manager";
  const { setPageHeading } = useContext(AppStateContext);
  const { getData } = APIServices();

  const api = {
    addMedia: `${apiPath.getUserChallenges}/add-media`,
  };

  const [searchText, setSearchText] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const navigate = useNavigate();
  const [selected, setSelected] = useState();
  const [send, setSend] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({
    categoryf: "",
    durationf: "",
  });

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ ...pagination, current: 1 });
  };

  const columns = [
    {
      title: "Challenge",
      dataIndex: "challenge",
      key: "challenge",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { challenger_challenge }) => {
        return challenger_challenge
          ? challenger_challenge?.challenge_id?.title
          : "-";
      },
    },
    {
      title: "Challenger",
      dataIndex: "challenger",
      key: "challenger",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { challenger }) => {
        return challenger ? (
          <div className="posed-by_--emaill">
            <p>{challenger?.name}</p>
            <p>{challenger?.email}</p>
          </div>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Invitee",
      dataIndex: "invitee",
      key: "invitee",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { receiver }) => {
        return receiver ?(
        <div className="posed-by_--emaill">
        <p>{receiver?.name}</p>
        <p>{receiver?.email}</p>
      </div>) : "-";
      },
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      width: 200,
      render: (_, { duration }) => {
        return duration ? duration : "-";
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"View Progress"} color={"purple"} key={"progress"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  navigate(`/user-challenge/view/${record._id}`, {
                    state: { data: record },
                  });
                }}
              >
                <i class="far fa-eye"></i>
              </Button>
            </Tooltip>
            {/* <Tooltip title={"Send Media"} color={"purple"} key={"Send Media"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setSend(true);
                }}
              >
                <i style={{ color: "fff" }} class="fa fa-paper-plane"></i>
              </Button>
            </Tooltip> */}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    getData(
      apiPath.getUserChallenges,
      { ...pagination, ...filter, search: debouncedSearchText },
      setList,
      setLoading,
      setPagination,
      pagination
    );
  }, [debouncedSearchText, startDate, endDate, refresh, filter]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const handleChange = (pagination, filters) => {
    getData(
      apiPath.getUserChallenges,
      { ...pagination, ...filter, search: debouncedSearchText },
      setList,
      setLoading,
      setPagination,
      pagination
    );
  };

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  const onChange = (key, value) => {
    setFilter((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"User Challenges"}
              extra={
                <>
                  <div className="button_group justify-content-end w-100">
                    <div className="role-wrap">
                      <Select
                        last20Years
                        showSearch
                        placeholder="Duration"
                        options={challengeDuration?.map((item) => ({
                          label: item?.name,
                          value: item?.value,
                        }))}
                        value={filter.durationf ? filter.durationf : undefined}
                        onChange={(value) => onChange("durationf", value)}
                      />
                    </div>
                    <div className="role-wrap">
                      <Select
                        last20Years
                        showSearch
                        placeholder="Category"
                        options={challengeCategory?.map((item) => ({
                          label: item?.name,
                          value: item?.value,
                        }))}
                        value={filter.categoryf ? filter.categoryf : undefined}
                        onChange={(value) => onChange("categoryf", value)}
                      />
                    </div>
                    <Search
                      // allowClear
                      className="search-input"
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Name, email, number"
                      title="Search By Name, email, number"
                    />
                    <Button
                      onClick={() => {
                        setFilter({
                          categoryf: "",
                          durationf: "",
                        });
                        setSearchText("");
                      }}
                      type="primary"
                      icon={<UndoOutlined />}
                    >
                      {"Reset"}
                    </Button>
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list?.data}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {send && (
        <SendMediaForm
          show={send}
          section={"Media"}
          useFor={"UserChallenge"}
          hide={() => {
            setSend(false);
            setSelected();
          }}
          api={api}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

export default Index;
